import { useComputed } from '@preact/signals'
import {
  approveGuardianLink,
  approveRequest,
  authError,
  clearAuthError,
  denyGuardianLink,
  denyRequest,
  fetchCurrentUser,
  fetchGuardianRequests,
  guardianRequests,
  hasProfile,
  identity,
  isAdult,
  isAuthenticated,
  isChild,
  isInitialized,
  isLinked,
  isLoading,
  login,
  logout,
  managedChildren,
  needsGuardian,
  profile,
  register,
  requestGuardianLink,
  resolveGuardianLinkToken,
  signup,
} from '../store/auth'

/**
 * Hook to access auth state and actions
 */
export function useAuth() {
  return {
    // State (reactive)
    isInitialized: useComputed(() => isInitialized.value),
    isLoading: useComputed(() => isLoading.value),
    isAuthenticated: useComputed(() => isAuthenticated.value),
    identity: useComputed(() => identity.value),
    profile: useComputed(() => profile.value),
    managedChildren: useComputed(() => managedChildren.value),
    guardianRequests: useComputed(() => guardianRequests.value),
    error: useComputed(() => authError.value),

    // Computed (reactive)
    isChild: useComputed(() => isChild.value),
    isAdult: useComputed(() => isAdult.value),
    isLinked: useComputed(() => isLinked.value),
    needsGuardian: useComputed(() => needsGuardian.value),
    hasProfile: useComputed(() => hasProfile.value),

    // Actions
    login,
    register,
    logout,
    signup,
    requestGuardianLink,
    clearAuthError,
    fetchCurrentUser,
    resolveGuardianLinkToken,
    approveGuardianLink,
    denyGuardianLink,
    fetchGuardianRequests,
    approveRequest,
    denyRequest,
  }
}
